// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__14LWD","notes":"Notes_notes__29Hu_"};